import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import PageRoutes from "@/utils/constants";

export function NeedHelpCard({ href = "#" }: { href?: string }) {
  return (
    <div className="border border-slate-200 rounded-xl p-3 bg-white">
      <div className="font-bold text-slate-900 mb-2 text-[15px]">
        Need help?
      </div>
      <div className="text-slate-500 mb-4 leading-snug text-[13px]">
        Visit our Support Center for more information.
      </div>
      <Link
        to={PageRoutes.ContactUS}
        className="inline-flex items-center gap-1.5 font-semibold text-sm text-action hover:underline"
      >
        Go to Support Center
        <ExternalLink className="w-3.5 h-3.5" strokeWidth={2} />
      </Link>
    </div>
  );
}
